import React from 'react';

const Icon = ({ size = '24', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...other}>
            <path
                d="M19.25 9.618a.744.744 0 0 1-.25.046H5a.744.744 0 0 1-.25-.046v8.296c0 1.31 1.027 2.336 2.25 2.336h10c1.223 0 2.25-1.026 2.25-2.336V9.618Zm0-1.99c0-1.31-1.027-2.335-2.25-2.335H7c-1.223 0-2.25 1.026-2.25 2.336v.581A.745.745 0 0 1 5 8.164h14a.74.74 0 0 1 .25.046v-.581Zm1.5 10.286c0 2.098-1.66 3.836-3.75 3.836H7c-2.09 0-3.75-1.738-3.75-3.836V7.63c0-1.772 1.183-3.286 2.81-3.715V3a.75.75 0 0 1 1.5 0v.793h8.69V3a.75.75 0 0 1 1.5 0v.87c1.724.356 3 1.919 3 3.759v10.285Z"
                fill={fill}
            />

            <path
                d="M7 17.22v-.077a1 1 0 0 1 2 0v.077a1 1 0 1 1-2 0Zm4.5 0v-.077a1 1 0 0 1 2 0v.077a1 1 0 1 1-2 0Zm0-4.192v-.077a1 1 0 1 1 2 0v.077a1 1 0 1 1-2 0Zm4 0v-.077a1 1 0 1 1 2 0v.077a1 1 0 1 1-2 0Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
